<script>

    let skills = ['C++', '.Net', 'Python', 'JavaScript', 'Rust', 'React', 'Django', 'Vue JS', 'Svelte', 'Java', 'Spring'];
    let checked_skills = [];

    let file_inputs = ['Photo', 'CV', 'Documents'];
    let cv;
    let photo;
    let documents;

    let show_dropdown = false;

    let input_value = "";

    let toggle_dropdown = () => {
        show_dropdown = !!input_value;
    }
    let addSkills = (item) => {
        checked_skills.push(item);
        checked_skills = checked_skills;
        input_value = "";
        show_dropdown = false;
    }
    let deleteSkill = (i) => {
        checked_skills.splice(i, 1);
        checked_skills = checked_skills;
    }
    let save = () => {
        if (checked_skills.length > 0 && cv && photo) {
            window.location.href = "/"
        }
    }

</script>

<div class="skills_container">

    <div class="skills_wrapper">

        <div class="inputs">
            <img src="assets/svgs/skills.svg" alt="">

            <div class="input_container">


                <input type="text" bind:value={input_value} on:input={toggle_dropdown} placeholder="Skills *"/>

            </div>
            {#if show_dropdown}

                <div class="dropdown_container">

                    {#each skills as skill}
                        <span class="dropdown_cell" on:click={() => {addSkills(skill)}}>{skill}</span>
                    {/each}

                </div>

            {/if}


        </div>

        {#if checked_skills.length > 0}

            <div class="cell_container">
                <div class="cell">

                    {#each checked_skills as cskill, i}

                        <span class="cell_content" on:click={() => deleteSkill(i)}>{cskill}</span>

                    {/each}
                </div>

            </div>

        {/if}

        
        <div class="upload_input">

            <img src="assets/svgs/document.svg" alt="">

            {#if !photo}
                <label for="photo">Photo *</label>
                <input bind:files={photo} id="photo" type="file" placeholder="Photo" accept="image/*, .jpg, .png" style="display: none" required>
            {:else}
                <span>Upload complete!</span>
            {/if}

        </div>

        <div class="upload_input">

            <img src="assets/svgs/document.svg" alt="">

            {#if !cv}
                <label for="cv">CV *</label>
                <input bind:files={cv} id="cv" type="file" placeholder="CV" accept=".doc, .docx, .pdf" style="display: none" required>
            {:else}
                <span>Upload complete!</span>
            {/if}



        </div>

        <div class="upload_input">

            <img src="assets/svgs/document.svg" alt="">

            {#if !documents}
                <label for="documents">Documents</label>
                <input bind:files={documents} id="documents" type="file" placeholder="Documents" accept=".doc, .docx, .pdf, .jpg, .png" multiple style="display: none">
            {:else}
                <span>Upload complete!</span>
            {/if}

        </div>


        <div class="btn-container">

            <button class="btn" on:click={save}>Save</button>

        </div>

    </div>

</div>

<style>
    .skills_container {
        display: flex;
        justify-content: center;
        margin-top: 10vw;
    }
    .skills_wrapper {
        width: 90%;
    }
    .inputs {
        display: flex;
        flex-direction: row;
        align-items: center;

        width: 95%;
        position: relative;

    }
    .inputs img {
        height: 6vw;
        width: 6vw;
        margin-right: 4vw;

    }
    .input_container {
        margin-bottom: unset;
        width: 100%;
        z-index: 2;

    }
    .input_container input {
        padding-left: 0;
        background-color: transparent;
    }
    .dropdown_container {
        position: absolute;
        width: 90%;
        display: flex;
        flex-direction: column;
        background-color: white;
        top: 100%;
        padding-left: 9vw;

    }
    .dropdown_container .dropdown_cell {
        padding: 4vw 0 4vw 0;
        border: none;
        border-bottom: 1px solid rgba(0,0,0,0.3);


    }
    .cell_container {
        width: 95%;
        margin-top: 1.5vw;
    }
    .cell {
        padding-left: 10vw;
        display: flex;
        flex-wrap: wrap;

    }
    .cell_container .cell .cell_content {
        border: 1px solid black;
        border-radius: 4px;
        padding: 0 2vw;
        margin: 0 2vw 1.5vw 0;
        font-size: 3vw;
        width: max-content;

    }

    .upload_input {
        margin-top: 10vw;
        display: flex;
        align-items: center;
        width: 95%;
    }
    .upload_input img {
        height: 6vw;
        width: 6vw;
        margin-right: 4vw;
    }
    .upload_input label, span {
        border: 1px solid rgba(0,0,0,0.3);
        width: 100%;
        padding: 8vw 4vw;
    }
    .btn-container {
        padding-top: 8vh;
    }

</style>